import React from 'react'
import { useCurrentTheme } from '../../../hooks/useCurrentTheme'
import { getContrastColor } from '../../../helpers/helpers'
import styles from './RangePositions.module.scss'

export function RangesPositionsEV({ player }) {
	const settings = useCurrentTheme()
	const posColor = settings.positions[player]
	const fontColorPlayer = getContrastColor(posColor)

	return (
		<span
			className={styles.positionLabel}
			style={{
				backgroundColor: posColor,
				color: fontColorPlayer,
			}}
		>
			{player}
		</span>
	)
}
